import { createParagraphToggle } from '../ParagraphToggle/utils';
import {
  ExplanationNode,
  ExplanationsNode,
  EXPLANATION,
  EXPLANATIONS,
  PLUGIN_EXPLANATON_PRESENT_TYPES,
} from './types';

export const createExplanations = ({
  label = '',
  visible = true,
  portalId = undefined,
  parentNodeType = undefined,
} = {}): ExplanationsNode => ({
  type: EXPLANATIONS,
  label,
  portalId,
  parentNodeType,
  children: [createExplanation()],
});

export const createExplanation = ({
  placeholder = 'Điền giải thích',
  forId = undefined,
  text = '',
} = {}): ExplanationNode => ({
  type: EXPLANATION,
  forId,
  children: [
    createParagraphToggle({
      label: '',
      text,
      toggle: false,
      placeholder,
      present: PLUGIN_EXPLANATON_PRESENT_TYPES.EXPLANATION,
      parentNodeType: EXPLANATIONS,
    }),
  ],
});
